import React, {ChangeEvent} from "react";
import styles from "./ToggleSwitch.module.css"

const ToggleSwitch = (props: {
  className: string,
  id: string,
  value: boolean,
  disabled?: boolean,
  onSwitch?: (value: boolean) => void
}) => {
  const { value } = props;

  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value === 'yes';
    if (props.onSwitch)
      props.onSwitch(newValue);
  }

  return (
    <form className={props.className}>
      <div className={styles.switch}>
        <input type='radio' id={`${props.id}-yes`} name={props.id} value='yes' disabled={props.disabled} checked={value} onChange={onChange} />
        <label htmlFor={`${props.id}-yes`}>Yes</label>

        <input type='radio' id={`${props.id}-no`} name={props.id} value='no' disabled={props.disabled} checked={!value} onChange={onChange} />
        <label htmlFor={`${props.id}-no`}>No</label>
      </div>
    </form>
  );
}

export default ToggleSwitch;
